export const onDocumentLoad = function(func) {
  if (!('HAS_EXECUTED_ON_DOCUMENT_LOAD' in window)) window.HAS_EXECUTED_ON_DOCUMENT_LOAD = false;
  const arr = window.ON_DOCUMENT_LOAD = window.ON_DOCUMENT_LOAD || [];
  if (func) arr.push(func);
  document.addEventListener("DOMContentLoaded", event => {
    if (window.HAS_EXECUTED_ON_DOCUMENT_LOAD) return;
    else {
      window.HAS_EXECUTED_ON_DOCUMENT_LOAD = true;
      arr.forEach(f => {
        try {
          f();
        } catch(e) {
          console.error(e);
        }
      });
    }
  });
}

export default onDocumentLoad;